module.exports = __webpack_public_path__ + "static/media/telegram.703e9025.svg";